export const FREE_CALL_CALENDAR_LINK =
  'https://calendly.com/ayble-team/learn-more-about-ayble';
export const LOCAL_STORAGE_USER_INFO_KEY = 'ayble-user-info';
export const GENDERS = ['Female', 'Male', 'Other', 'Prefer not to say'];
